import { buildCommerceEngine, CommerceEngine } from "@coveo/headless/commerce";
import { getCoveoSearchHost, getAccessToken } from "./commerce-engine-config";

export const getEngine = () => {
  if (_engine !== null) {
    return _engine;
  }

  _engine = buildCommerceEngine({
    configuration: {
      organizationId: process.env.NEXT_PUBLIC_CoveoOrganizationId ?? "",
      accessToken: process.env.NEXT_PUBLIC_CoveoSearchToken ?? "",
      renewAccessToken: getAccessToken,      
      analytics: {
        trackingId: process.env.NEXT_PUBLIC_CoveoTrackingId ?? "",
      },
      context: {
        language: "en",
        country: "US",
        currency: "USD",
        view: {
          url: `${getCoveoSearchHost()}/`,
        },
      },
    },
  });

  return _engine;
};

let _engine: CommerceEngine | null = null;
